import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-986c33a0")

_pushScopeId("data-v-986c33a0")
const _hoisted_1 = {
  key: 0,
  class: "error-message"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (0 < _ctx.messages?.length)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.messages, (msg) => {
          return (_openBlock(), _createBlock("span", {
            key: msg,
            textContent: _toDisplayString(msg)
          }, null, 8, ["textContent"]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
})